const DistanceUnit = Object.freeze({
	KILOMETERS: "km",
	MILES: "mi",
});
export default DistanceUnit;